export default "__VITE_ASSET__9AXzA0qs__"